import { useImage } from "@chatfood/design-system";
import { useSeoMeta } from "#imports";

type IRichCard = {
  title: string;
  description?: string;
  image?: string;
};

export const useRichCard = ({ title, description, image }: IRichCard) => {
  const { optimize } = useImage();

  const optimizedImage = image
    ? optimize(image, {
        w: 800,
        fit: "crop",
      })
    : undefined;

  useSeoMeta({
    title: () => title,
    ogTitle: () => title,
    twitterTitle: () => title,

    description: () => description,
    ogDescription: () => description,
    twitterDescription: () => description,

    ogImage: () => optimizedImage,
    ogImageUrl: () => optimizedImage,
    twitterImage: () => optimizedImage,

    twitterCard: () => "summary_large_image",
  });
};
